class Toast {
    show(icon, title, message, timeout = 3000, error = false, alert = false) {
        const toast = this._createElement(icon, title, message, error, alert);

        setTimeout(() => toast.classList.remove('hidden'), 1);
        setTimeout(() => this._hide(toast), timeout);

        return toast;
    }

    _createElement(icon, title, message, error, alert) {
        const markup = `
            <div class="toast-message__section">
                <svg class="toast-message__icon" width="32" height="32" viewbox="0 0 172 185">
                    <use xlink:href="/cldstatic/vdp/%%FINGERPRINT%%/spritemap.svg#${icon}" />
                </svg>
            </div>
            <div class="toast-message__section leftmargin">
                <p class="toast-message__title">${title}</p>
                <p class="toast-message__text">${message}</p>
            </div>`;

        const element = document.createElement('div');
        element.classList.add('toast-message', 'hidden');
        if (error) {
            element.classList.add("error");
        }
        if (alert) {
            element.classList.add("alert");
        }
        element.innerHTML = markup;
        document.body.appendChild(element);

        return element;
    }

    _hide(element) {
        element.classList.add('hidden');
        setTimeout(() => document.body.removeChild(element), 1000);
    }
}

export default new Toast;